import React from 'react'
import { useLocation } from 'react-router-dom'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import QuestPaymentStatus from '../components/quests/QuestPaymentStatus'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)

const QuestPaymentStatusPage = () => {
  const location = useLocation()
  const query = new URLSearchParams(location?.search)
  const payment_intent_client_secret = query.get('payment_intent_client_secret')

  return (
    <Elements
      stripe={stripePromise}
      options={{ clientSecret: payment_intent_client_secret }}>
      <QuestPaymentStatus />
    </Elements>
  )
}

export default QuestPaymentStatusPage
